"use client";

import React, { useState, useEffect } from "react";
import { MapPin, Navigation, Clock, Radio } from "lucide-react";
import { Card, CardContent, CardHeader, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
interface TimeLeft {
  hours: number;
  minutes: number;
  seconds: number;
}
export default function TrackTheTruck() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    hours: 4,
    minutes: 23,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        }
        if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        if (prev.hours > 0) {
          return {
            ...prev,
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (value: number) => value.toString().padStart(2, "0");
  return <section data-section-id="240464" id="where-to-find-us" className="bg-background text-foreground relative w-full h-[700px] md:h-[800px] overflow-hidden flex items-center !bg-[url(https://key-arachnid-1.10web.cloud/wp-content/uploads/2026/05/Untitled-design-129.png)]">
      {}
      <div className="absolute inset-0 z-0 bg-zinc-100">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1656752/img/service_areas_aerial_map.png')] bg-cover bg-center opacity-100 grayscale"></div>
        
        {}
        <div className="absolute inset-0 bg-[url(https://key-arachnid-1.10web.cloud/wp-content/uploads/2026/05/Untitled-design-129.png)] bg-cover bg-center opacity-100"></div>

        {}
        <div className="absolute top-[35%] left-[20%] md:top-[40%] md:left-[25%] flex flex-col items-center z-10">
          <div className="relative">
            {}
            <div className="absolute -inset-4 bg-primary/20 rounded-full animate-ping"></div>
            <div className="absolute -inset-3 bg-primary/30 rounded-full animate-pulse"></div>
            
            <div className="relative bg-primary text-primary-foreground p-4 rounded-none shadow-none border-2 border-background">
              <MapPin className="size-8" />
            </div>
          </div>
          {}
          <div className="w-8 h-2 bg-black/20 rounded-[100%] mt-4 blur-[2px]"></div>
        </div>
      </div>

      {}
      <div className="container relative z-20 mx-auto px-4 h-full flex flex-col justify-end md:justify-center items-end pb-8 md:pb-0 pointer-events-none">
        
        {}
        <Card className="w-full max-w-md bg-background/95 backdrop-blur-sm border-border shadow-none pointer-events-auto rounded-none border-l-4 border-l-primary">
          <CardHeader className="pb-4 border-b border-border/50">
            <div className="flex items-center justify-between">
              <Badge variant="outline" className="bg-transparent border-primary/20 text-primary font-default tracking-widest px-3 py-1 rounded-none">
                <Radio className="size-3 mr-2 animate-pulse text-primary" />
                CURRENT SERVICE AREA
              </Badge>
              <span className="text-xs font-default text-muted-foreground tracking-wider">EST. 2024</span>
            </div>
          </CardHeader>
          
          <CardContent className="pt-6 pb-2 space-y-6">
            <div>
              <p className="text-sm font-default text-muted-foreground tracking-widest mb-1 uppercase">Headquarters</p>
              <h3 className="text-3xl md:text-4xl font-serif font-normal tracking-wider uppercase text-foreground">
                FIND US
              </h3>
              <p className="text-muted-foreground mt-2 font-default text-sm">
                Based in Tavistock, Ontario. Serving Oxford, Norfolk, Perth, Huron, and Middlesex Counties.
              </p>
            </div>

            <div className="bg-muted/50 border border-border p-4 rounded-none">
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center text-sm font-default text-muted-foreground tracking-widest uppercase">
                  <Clock className="size-4 mr-2 text-primary" />
                  Operating Hours
                </div>
              </div>
              <div className="flex items-baseline space-x-2 font-default">
                <div className="flex flex-col items-center">
                  <span className="text-4xl font-serif font-normal text-foreground tracking-wider">
                    08
                  </span>
                  <span className="text-[10px] text-muted-foreground tracking-widest uppercase mt-1">AM</span>
                </div>
                <span className="text-2xl text-primary/50 self-start mt-1">-</span>
                <div className="flex flex-col items-center">
                  <span className="text-4xl font-serif font-normal text-foreground tracking-wider">
                    04
                  </span>
                  <span className="text-[10px] text-muted-foreground tracking-widest uppercase mt-1">PM</span>
                </div>
                <span className="text-2xl text-primary/50 self-start mt-1">|</span>
                <div className="flex flex-col items-center">
                  <span className="text-4xl font-serif font-normal text-primary tracking-wider">
                    M-F
                  </span>
                  <span className="text-[10px] text-primary/70 tracking-widest uppercase mt-1">WEEK</span>
                </div>
              </div>
            </div>
          </CardContent>

          <CardFooter className="pt-4 pb-6">
            <Button className="w-full h-14 text-lg font-default font-normal tracking-widest uppercase rounded-full bg-primary hover:bg-chart-2 text-primary-foreground group relative overflow-hidden transition-colors duration-300">
              <span className="relative z-10 flex items-center">
                <Navigation className="mr-2 size-5 group-hover:animate-bounce" />
                Contact Us
              </span>
            </Button>
          </CardFooter>
        </Card>

      </div>
    </section>;
}